import {  Field, withDatasourceCheck, RichTextField, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

type PolicyProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    Title:Field<string>;
    Description:RichTextField;

  };
  locale: string
  lang: string
};

const Policy = (props: PolicyProps): JSX.Element => {
  return(
    <div className={`flex flex-col gap-7 px-3 2xl:px-28 xl:px-22 md:px-8 xl:py-40 py-32 ${props?.locale == props?.lang ? "rtl":""}`}>
      <h1 className='text-[#6E1946] font-bold 2xl:text-[42px] xl:text-[32px] text-[22px]'>{props?.fields?.Title?.value}</h1>
      <RichText className="text-[#0F2837] xl:text-[16px] text-[14px] xl:mx-10 mx-5 text-justify" field={props?.fields?.Description} />
    </div>
  );
}

export default withDatasourceCheck()<PolicyProps>(Policy);
